// noinspection JSUnusedGlobalSymbols

import {
    addDays,
    addMonths,
    formatISO,
    parseISO,
    format,
    parse as parseDateFns,
    fromUnixTime,
} from 'date-fns';
import { captureException } from '@sentry/react';

export function formatDate(val: Date | string): string {
    try {
        return formatISO(parse(val), { representation: 'date' });
    } catch (error) {
        captureException(error);
        return typeof val == 'string' ? val : 'Invalid Date';
    }
}

export function formatDateTime(val: Date | string): string {
    try {
        return formatISO(parse(val), { representation: 'complete' });
    } catch (error) {
        captureException(error);
        return typeof val == 'string' ? val : 'Invalid Date';
    }
}

export function formatDateOnly(val: Date | string): string {
    try {
        return format(parse(val), 'yyyy-MM-dd');
    } catch (error) {
        captureException(error);
        return typeof val == 'string' ? val : 'Invalid Date';
    }
}

export function parse(val: Date | string): Date {
    return val instanceof Date ? val : parseISO(val);
}
export function parseDate(val: Date | string): Date {
    return val instanceof Date ? val : parseISO(val);
}

export function calcularFechaProximoPago(
    dia_cobro: number,
    fecha_ultimo_cobro: Date | string
) {
    // console.log('fecha_ultimo_cobro', fecha_ultimo_cobro);
    const mas_un_mes = addMonths(parse(fecha_ultimo_cobro), 1);
    // try {
    //     console.log('agrego 1 mes', formatDate(mas_un_mes));
    // } catch (e) {
    //     console.error(`Falló para ${fecha_ultimo_cobro}+1M`, mas_un_mes);
    // }
    const nueva = new Date(
        mas_un_mes.getFullYear(),
        mas_un_mes.getMonth(),
        dia_cobro
    );
    // console.log('hago una nueva con el dia forzado', formatDate(nueva));
    //si son distintos, es porque la nueva se pasó, entonces uso la anterior
    if (nueva.getMonth() !== mas_un_mes.getMonth()) {
        // console.log('se pasó');
        return formatDate(mas_un_mes);
    }
    return formatDate(nueva);
}

export function add30days(fecheaCreacion: Date | string) {
    return formatDate(addDays(parse(fecheaCreacion), 29));
}

export function addTrialDays(fecheaCreacion: Date | string, days: number) {
    return addDays(parse(fecheaCreacion), days - 1);
}
/**
 * Convierte un string con el formato dateOnly a fecha, o explita si es inválido
 * @param val
 */
export function databaseDateOnlyToJsDate(val: string): Date {
    const date = validateDateOnlyString(val);
    if (date === false) {
        throw new Error(`Fecha incorrecta: ${JSON.stringify(val)}`);
    }
    return date;
}
/**
 * Valida que el string tenga el dato correcto, y si es así, lo devueve como Fecha de JS
 * Si no es correcto, devuelve false
 * @param val
 */
export function validateDateOnlyString(val: string): Date | false {
    const date = parseDateFns(val, 'yyyy-MM-dd', new Date());
    if (Number.isNaN(date.getTime())) {
        return false;
    }
    return date;
}

export function formatUnitTimestamp(timestamp: number): string {
    return formatDate(fromUnixTime(timestamp / 1000));
}
